import fetch from '@/api/fetch'

/**
 * 获取抢购滚动轮播数据
 */
export function getOrderBubble(params) {
  return fetch({
    url: '/product/getOrderBubble',
    params
  })
}

/**
 * 获取拼购滚动轮播数据
 */
export function grouponOrderBubble(params) {
  return fetch({
    url: '/groupon/getOrderBubble',
    params
  })
}
